<template>
  <div class="col-12 col-md-6 col-lg-3 col-xl-3 item px-md-1 mb-2">
    <div class="thumbnail card d-none d-md-flex" @click="goToStore" @mouseover="isHovered = true" @mouseleave="isHovered = false">
      <div class="img-event intrinsic">
        <img :src="item.thumbnail_url" alt="" class="thumbnail-image card-img-top intrinsic-item p-0" v-if="item.thumbnail_url">
        <img src="../../image/placeholder-square.png" alt="" class="thumbnail-image card-img-top intrinsic-item p-0" v-else>
      </div>
      <div class="card-body abs p-3">
        <div class="row mx-0 h-100">
          <div class="col-12 p-0">
            <h6 class="card-title truncate_small mb-0">
              {{ item.title }}
            </h6>
          </div>
          <div class="col-12 p-0 mt-2" v-if="isHovered">
            <div class="row m-0">
              <div class="col-12 p-0">
                <p class="card-text truncate">{{ item.description | shortDescription}}</p>
              </div>
              <div class="col-12 p-0 lead my-1">
                R {{ item.price }}
              </div>
              <div class="col-12 p-0 align-self-end dark-mode">
                <button class="btn btn-outline w-100">
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card d-md-none" @click="goToStore">
      <div class="row m-0">
        <div class="col-6 p-0 text-center">
          <img :src="item.thumbnail_url" alt="" class="img-fluid img_height">
        </div>
        <div class="col p-2 h-100">
          <div class="row m-0 h-100">
            <div class="col-12 p-0 truncate_small">
              <b>{{ item.title }}</b>
            </div>
            <div class="col-12 p-0 mt-2" v-if="item.description">
              <p class="card-text truncate">{{ item.description | shortDescription}}</p>
            </div>
            <div class="col-12 p-0 lead text-right my-2">
              R {{ item.price }}
            </div>
            <div class="col-12 p-0 align-self-end">
              <button class="btn btn-outline w-100">
                View
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['item', 'storeLink'],
  data () {
    return {
      isHovered: false
    }
  },
  methods: {
    ...mapActions(['setShopId']),
    goToStore () {
      this.setShopId(this.storeLink)
      this.$router.push(`/${this.storeLink}/product/${this.item.id}`)
    },
    hoverItem () {
      this.isHovered = !this.isHovered
    }
  },
  filters: {
    shortDescription (value) {
      if (value && value.length > 150) {
        return value.substring(0, 150) + '...'
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
div.card {
  height: 100%;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
  background-color: var(--light-color);
  border: none;
}
.dark-mode div.card {
  background-color: var(--dark-color-off);
}
.img_height {
  max-height: 35vh;
}
.card:hover {
  cursor: pointer;
  -webkit-box-shadow: 0 0 8px 1px var(--dark-color-03);
  box-shadow: 0 0 8px 1px var(--dark-color-03);
}
.card-img, .card-img-top {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.card-text {
  font-size: 0.875rem;
  line-height: 1.2;
}
.truncate {
  word-wrap: break-word;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 3;
}
.truncate_small {
  word-wrap: break-word;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 2;
}
.intrinsic {
  padding-top: 0;
  position: relative;
  height: 250px;
  width: 100%;
  background-color: var(--dark-color-01);
}
.dark-mode .intrinsic {
  background-color: var(--light-color-04);
}
.intrinsic-item {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
@media (min-width: 768px) {
  .img-event {
    width: 30%;
    float: left;
    padding: 0 !important;
    margin: 0;
  }
  .intrinsic {
    padding-top: 0;
    position: relative;
    height: 300px;
    width: 100%;
    background-color: var(--dark-color-01);
  }
  .card-body {
    float: left;
    width: 100%;
    margin: 0;
    position: absolute;
    bottom: 0;
    background-color: var(--dark-color-08);
    color: var(--light-color);
  }
  .card-text {
    font-size: 0.75rem;
    line-height: 1.2;
  }
}
</style>
<style lang="scss" scoped>

.intrinsic {
  padding-top: 0;
  position: relative;
  // height: 20vh;
  width: 100%;
  background-color: var(--dark-color-01);
}
.dark-mode .intrinsic {
  background-color: var(--light-color-04);
}
.intrinsic-item {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.list-group-item {
  float: none;
  width: 100%;
  background-color: #fff;
  margin-bottom: 30px;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 1rem;
  border: 0;
  .thumbnail {
    display: inline-block;
    width: 100%;
  }
  .img-event {
    width: 20%;
    float: left;
    padding: 0 !important;
    margin: 0;
    height: auto;
  }

  .thumbnail-image {
    position: static;
  }

  .card-body {
    float: left;
    width: 80%;
    margin: 0;
  }
}

.item.list-group-item:before, .item.list-group-item:after
{
    display: table;
    content: " ";
}

.item.list-group-item:after {
  clear: both;
}
</style>
